<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <div v-if="numberOfPages > 1 || role == 'booster'">
      <v-fab-transition>
        <v-btn
          data-testid="open-activity-feed-icon"
          elevation="2"
          fixed
          left
          :color="mobile() ? '#F0F0F0' : ''"
          fab
          top
          :class="{
            'trial-absolute-button':
              ((productPlan.attributes &&
                productPlan.attributes.name == 'Pro Trial') ||
                subscriptionEnds ||
                (productPlan.meta &&
                  (productPlan.meta.plan_properties.status == 'incomplete' ||
                    productPlan.meta.plan_properties.status == 'past_due'))) &&
              mobile(),
            'trial-absolute-button-md':
              ((productPlan.attributes &&
                productPlan.attributes.name == 'Pro Trial') ||
                subscriptionEnds ||
                (productPlan.meta &&
                  (productPlan.meta.plan_properties.status == 'incomplete' ||
                    productPlan.meta.plan_properties.status == 'past_due'))) &&
              !mobile(),
            'mt-13 mt-md-15':
              !productPlan.attributes ||
              (productPlan.attributes &&
                productPlan.attributes.name != 'Pro Trial' &&
                !subscriptionEnds &&
                !(
                  productPlan.meta &&
                  (productPlan.meta.plan_properties.status == 'incomplete' ||
                    productPlan.meta.plan_properties.status == 'past_due')
                )),
          }"
          style="z-index: 4"
          @click="updateDrawerState"
        >
          <v-icon medium> mdi-menu </v-icon>
        </v-btn>
      </v-fab-transition>
      <v-navigation-drawer
        v-if="!loadingData"
        v-model="drawer"
        class="mt-0 navbar-left-activity"
        overlay-opacity="1"
        hide-overlay
        clipped
        app
        color="background"
        fluid
        :width="mobile() ? '375' : '350'"
        data-testid="navigation-drawer"
        style="z-index: 6"
        disable-resize-watcher
        stateless
      >
        <div style="position: relative">
          <h3 class="pa-6">
            {{ $t("activityPageFeedTitle") }}
          </h3>
          <v-spacer />
          <v-btn
            data-testid="close-activity-feed-icon"
            color="greytext--text "
            absolute
            top
            right
            icon
            @click.stop="updateDrawerState"
          >
            <v-icon>mdi-backburger</v-icon>
          </v-btn>
        </div>
        <div class="px-4 pb-6" v-if="role != 'booster'">
          <v-progress-linear :value="completedPercentage" :color="completedPercentage == 0 ? 'greytextlight' : 'success'" height="16" class="rounded-xxl" data-testid="progress-linear"><span class="text-caption">{{ completedPercentage }}%</span></v-progress-linear>
        </div>
        <draggable
          v-if="role == 'booster'"
          data-testid="draggable-feed"
          class="areaNavBar list-group mx-auto pb-16"
          tag="v-list"
          :list="list"
          :group="{ name: 'g1' }"
          ghost-class="ghost-first"
          :handle="mobile() ? '.handle' : ''"
          @start="onStart"
          @end="onEnd"
          :move="onMove"
        >
          <v-list-group
            v-for="listItem in list"
            :key="listItem.id"
            v-model="listItem.active"
            no-action
            router
            :class="{
              'v-list-item--active':
                $route.params.pageId == listItem.entity_id ||
                $route.params.quizId == listItem.entity_id ||
                $route.params.scormId == listItem.entity_id ||
                $route.params.checklistId == listItem.entity_id ||
                $route.params.surveyId == listItem.entity_id,
              section: listItem.entity_type == 'section',
            }"
            color="anchor"
            class="menu_text pa-0 pl-0"
            :ripple="false"
            :prepend-icon="listItem.entity_type == 'section' ? '$expand' : ''"
            append-icon=""
            sub-group
            @click="updateDrawerStateOnClickItem(listItem.entity_type)"
            @click.prevent="
              listItem.entity_type == 'activity_page'
                ? redirectToActivityPage(listItem.entity_id)
                : listItem.entity_type == 'quiz'
                ? redirectToActivityQuiz(listItem.entity_id)
                : listItem.entity_type == 'scorm'
                ? redirectToActivityScorm(listItem.entity_id)
                : listItem.entity_type == 'checklist'
                ? redirectToActivityChecklist(listItem.entity_id)
                : listItem.entity_type == 'survey'
                ? redirectToActivitySurvey(listItem.entity_id)
                : ''
            "
            :dragid="listItem.id"
          >
            <v-icon
              v-if="listItem.entity_type == 'section'"
              slot="prependIcon"
              class="section-icon"
            >
              {{ "$expand" }}
            </v-icon>
            <template v-slot:activator>
              <v-list-item
                data-testid="activity-page-item"
                class="pa-0 activity-page-item"
                :class="{
                  'v-list-item--active':
                    $route.params.pageId == listItem.entity_id ||
                    $route.params.quizId == listItem.entity_id ||
                    $route.params.scormId == listItem.entity_id ||
                    $route.params.checklistId == listItem.entity_id ||
                    $route.params.surveyId == listItem.entity_id,
                }"
              >
                <v-row no-gutters>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-col
                        :cols="!listItem.edit ? 8 : 11"
                        class="text-no-wrap text-truncate d-flex"
                        v-on="on"
                      >
                        <v-icon
                          v-if="
                            listItem.entity_type == 'activity_page' ||
                            listItem.entity_type == 'scorm'
                          "
                          class="v-list-item__icon"
                        >
                          mdi-text
                        </v-icon>
                        <v-icon
                          v-if="listItem.entity_type == 'quiz'"
                          class="v-list-item__icon"
                        >
                          mdi-chat-question-outline
                        </v-icon>
                        <v-icon
                          v-if="listItem.entity_type == 'checklist'"
                          class="v-list-item__icon"
                        >
                          mdi-order-bool-ascending-variant
                        </v-icon>
                        <v-icon
                          v-if="listItem.entity_type == 'survey'"
                          class="v-list-item__icon"
                        >
                          mdi-help-box-multiple-outline
                        </v-icon>
                        <v-icon
                          v-if="
                            listItem.rule_item_id != null &&
                            sharingSettings != 3
                          "
                          color="warning"
                          class="v-list-item__icon"
                          dense
                        >
                          mdi-lightning-bolt-circle
                        </v-icon>
                        <v-icon
                          v-if="
                            listItem.rule_available_after != null &&
                            listItem.rule_fulfilled == false
                          "
                          color="warning"
                          class="v-list-item__icon"
                          dense
                        >
                          mdi-clock
                        </v-icon>
                        <span
                          v-if="!listItem.edit"
                          class="
                            title
                            text-truncate text-body-2
                            align-self-center
                          "
                        >
                          <v-chip
                            v-if="!listItem.is_published"
                            class="activity-feed-draft-tag"
                            data-testid="draft-available-chip"
                            color="warning"
                            text-color="black"
                            >{{ $t("draft") }}</v-chip
                          >
                          {{ listItem.title }}
                        </span>
                        <v-form
                          v-else
                          ref="form"
                          v-model="valid"
                          v-click-outside="onClickOutside"
                          class="d-flex align-self-end"
                          @submit.prevent
                          @keydown.enter.prevent
                        >
                          <v-text-field
                            v-model="listItem.title"
                            autofocus
                            data-testid="title-input"
                            class="mt-0 pt-0"
                            hide-details
                            :append-icon="valid ? 'mdi-check-bold' : ''"
                            :rules="titleRules"
                            @click:append="editTitle(listItem)"
                            @keydown.enter="editTitle(listItem)"
                            @click.stop.prevent
                            @keydown.enter.stop.prevent
                          />
                        </v-form>
                      </v-col>
                    </template>
                    <span>{{ listItem.title }}</span>
                  </v-tooltip>
                  <v-col
                    v-if="
                      listLiveUsers.find(
                        (user) => user.entity_id == listItem.entity_id
                      )
                    "
                    data-testid="editor-user"
                    cols="2"
                    class="text-center align-self-center"
                  >
                    <v-avatar
                      size="37"
                      :style="
                        `border:3px solid; color: #` +
                        intToRGB(
                          hashCode(
                            listLiveUsers.find(
                              (user) => user.entity_id == listItem.entity_id
                            ).first_name +
                              listLiveUsers.find(
                                (user) => user.entity_id == listItem.entity_id
                              ).last_name
                          )
                        )
                      "
                      class="avatar"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <img
                            v-if="
                              listLiveUsers.find(
                                (user) => user.entity_id == listItem.entity_id
                              ).avatar == null
                            "
                            src="../assets/user_images/profile-avatar.png"
                            v-on="on"
                          />
                          <img
                            v-else
                            :src="
                              listLiveUsers.find(
                                (user) => user.entity_id == listItem.entity_id
                              ).avatar
                            "
                            v-on="on"
                          />
                        </template>
                        <span
                          >{{
                            listLiveUsers.find(
                              (user) => user.entity_id == listItem.entity_id
                            ).first_name +
                            " " +
                            listLiveUsers.find(
                              (user) => user.entity_id == listItem.entity_id
                            ).last_name
                          }}
                          {{ $t("someoneIsEditing") }}
                        </span>
                      </v-tooltip>
                    </v-avatar>
                  </v-col>

                  <v-col
                    v-else
                    cols="2"
                    class="text-center align-self-center"
                  />

                  <v-col
                    v-if="
                      !listItem.edit && isAuth && role == 'booster' && !mobile()
                    "
                    cols="2"
                    class="text-right align-self-center"
                  >
                    <v-menu ref="menuRef" offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="dots-vertical"
                          icon
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon data-testid="threedots-icon">
                            mdi-dots-vertical
                          </v-icon>
                        </v-btn>
                      </template>
                      <v-list data-testid="menu-list">
                        <v-list-item
                          data-testid="edit-title-item"
                          router
                          @click.stop.prevent="showEditTitleField(listItem)"
                        >
                          <v-list-item-title>
                            {{ $t("editTitle") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-tooltip v-if="sharingSettings == 3" bottom>
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-list-item
                                v-if="listItem.entity_type != 'section'"
                                data-testid="set-activity-rule"
                                :disabled="
                                  listItem.id == activityDefaultItemId ||
                                  listItem.is_published == false ||
                                  sharingSettings == 3 ||
                                  (productPlan.attributes &&
                                    productPlan.attributes.name == 'Free')
                                "
                                router
                                @click.stop="
                                  selectedActivityItem = listItem;
                                  (dialogVisibleSetRule =
                                    listItem.id == activityDefaultItemId ||
                                    listItem.is_published == false
                                      ? false
                                      : true),
                                    (confirmationDialogTitle = $t(
                                      'confirmationDialogTitleSetRule'
                                    )),
                                    (confirmationDialogSubmitBtn = $t('save'));
                                  confirmationDialogCancelBtn = $t('cancel');
                                "
                              >
                                <v-list-item-title v-on="on">
                                  {{ $t("rule") }}
                                  <v-chip
                                    v-if="
                                      productPlan.attributes &&
                                      productPlan.attributes.name == 'Free'
                                    "
                                    class="rounded-lg ml-2 px-2"
                                    x-small
                                    color="accent"
                                    text-color="white"
                                    >PRO</v-chip
                                  >
                                </v-list-item-title>
                              </v-list-item>
                            </div>
                          </template>
                          <span>{{
                            $t("rulesInOpenActivityNotApplicableTooltip")
                          }}</span>
                        </v-tooltip>
                        <v-list-item
                          v-if="
                            listItem.entity_type != 'section' &&
                            sharingSettings != 3 
                          "
                          data-testid="set-activity-rule"
                          :disabled="
                            listItem.id == activityDefaultItemId ||
                            listItem.is_published == false ||
                            sharingSettings == 3 ||
                            (productPlan.attributes &&
                              productPlan.attributes.name == 'Free')
                          "
                          router
                          @click.stop="
                            selectedActivityItem = listItem;
                            (dialogVisibleSetRule =
                              listItem.id == activityDefaultItemId ||
                              listItem.is_published == false
                                ? false
                                : true),
                              (confirmationDialogTitle = $t(
                                'confirmationDialogTitleSetRule'
                              )),
                              (confirmationDialogSubmitBtn = $t('save'));
                            confirmationDialogCancelBtn = $t('cancel');
                          "
                        >
                          <v-list-item-title
                            >{{ $t("rule") }}
                            <v-chip
                              v-if="
                                productPlan.attributes &&
                                productPlan.attributes.name == 'Free'
                              "
                              class="rounded-lg ml-2 px-2"
                              x-small
                              color="accent"
                              text-color="white"
                              >PRO</v-chip
                            >
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="listItem.entity_type != 'section'"
                          data-testid="duplicate-draft-item"
                          router
                          :disabled="
                            listItem.is_published == true &&
                            listItem.has_draft == false
                          "
                          @click="duplicateDraftFeedItemActivity(listItem)"
                        >
                          <v-list-item-title>
                            {{ $t("duplicateDraftActivityFeedItem") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="listItem.entity_type != 'section'"
                          data-testid="duplicate-published-item"
                          router
                          :disabled="listItem.is_published == false"
                          @click="duplicatePublishedFeedItemActivity(listItem)"
                        >
                          <v-list-item-title>
                            {{ $t("duplicatePublishedActivityFeedItem") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="
                            !listItem.edit &&
                            listItem.entity_type == 'activity_page'
                          "
                          data-testid="delete-activity-item-page"
                          :disabled="
                            listLiveUsers.some(
                              (user) => user.entity_id == listItem.entity_id
                            )
                          "
                          router
                          @click.stop="
                            selectedActivityFeedIdForDeletion =
                              listItem.entity_id;
                            (dialogVisibleDelete = true),
                              (confirmationDialogTitle = $t(
                                'confirmationDialogTitleDeleteActivityPage'
                              )),
                              (confirmationDialogText = $t(
                                'confirmationDialogTextDeleteActivityPage'
                              )),
                              (confirmationDialogSubmitBtn = $t('delete'));
                            confirmationDialogCancelBtn = $t('no');
                            entityType='page';
                          "
                        >
                          <v-list-item-title>
                            {{ $t("delete") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="
                            !listItem.edit && listItem.entity_type == 'quiz'
                          "
                          data-testid="delete-activity-item-quiz"
                          :disabled="
                            listLiveUsers.some(
                              (user) => user.entity_id == listItem.entity_id
                            )
                          "
                          router
                          @click.stop="
                            selectedActivityFeedIdForDeletion =
                              listItem.entity_id;
                            (dialogVisibleDelete = true),
                              (confirmationDialogTitle = $t(
                                'confirmationDialogTitleDeleteActivityQuiz'
                              )),
                              (confirmationDialogText = $t(
                                'confirmationDialogTextDeleteActivityQuiz'
                              )),
                              (confirmationDialogSubmitBtn = $t('delete'));
                            confirmationDialogCancelBtn = $t('no');
                            entityType='quiz'
                          "
                        >
                          <v-list-item-title>
                            {{ $t("delete") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="
                            !listItem.edit && listItem.entity_type == 'scorm'
                          "
                          data-testid="delete-activity-item-scorm"
                          :disabled="
                            listLiveUsers.some(
                              (user) => user.entity_id == listItem.entity_id
                            )
                          "
                          router
                          @click.stop="
                            selectedActivityFeedIdForDeletion =
                              listItem.entity_id;
                            (dialogVisibleDelete = true),
                              (confirmationDialogTitle = $t(
                                'confirmationDialogTitleDeleteActivityScorm'
                              )),
                              (confirmationDialogText = $t(
                                'confirmationDialogTextDeleteActivityScorm'
                              )),
                              (confirmationDialogSubmitBtn = $t('delete'));
                            confirmationDialogCancelBtn = $t('no');
                            entityType='scorm'
                          "
                        >
                          <v-list-item-title>
                            {{ $t("delete") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="
                            !listItem.edit &&
                            listItem.entity_type == 'checklist'
                          "
                          data-testid="delete-activity-item-checklist"
                          :disabled="
                            listLiveUsers.some(
                              (user) => user.entity_id == listItem.entity_id
                            )
                          "
                          router
                          @click.stop="
                            selectedActivityFeedIdForDeletion =
                              listItem.entity_id;
                            (dialogVisibleDelete = true),
                              (confirmationDialogTitle = $t(
                                'confirmationDialogTitleDeleteActivityChecklist'
                              )),
                              (confirmationDialogText = $t(
                                'confirmationDialogTextDeleteActivityChecklist'
                              )),
                              (confirmationDialogSubmitBtn = $t('delete'));
                            confirmationDialogCancelBtn = $t('no');
                            entityType='checklist'
                          "
                        >
                          <v-list-item-title>
                            {{ $t("delete") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="
                            !listItem.edit &&
                            listItem.entity_type == 'survey'
                          "
                          data-testid="delete-activity-item-survey"
                          :disabled="
                            listLiveUsers.some(
                              (user) => user.entity_id == listItem.entity_id
                            )
                          "
                          router
                          @click.stop="
                            selectedActivityFeedIdForDeletion =
                              listItem.entity_id;
                            (dialogVisibleDelete = true),
                              (confirmationDialogTitle = $t(
                                'confirmationDialogTitleDeleteActivitySurvey'
                              )),
                              (confirmationDialogText = $t(
                                'confirmationDialogTextDeleteActivitySurvey'
                              )),
                              (confirmationDialogSubmitBtn = $t('delete'));
                            confirmationDialogCancelBtn = $t('no');
                            entityType='survey'
                          "
                        >
                          <v-list-item-title>
                            {{ $t("delete") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="
                            !listItem.edit && listItem.entity_type == 'section'
                          "
                          data-testid="delete-activity-item-section"
                          router
                          @click.stop="
                            selectedActivityFeedIdForDeletion =
                              listItem.entity_id;
                            (dialogVisibleDelete = true),
                              (confirmationDialogTitle = $t(
                                'confirmationDialogTitleDeleteActivitySection'
                              )),
                              (confirmationDialogText = $t(
                                'confirmationDialogTextDeleteActivitySection'
                              )),
                              (confirmationDialogSubmitBtn = $t('delete'));
                            confirmationDialogCancelBtn = $t('no');
                            entityType='section'
                          "
                        >
                          <v-list-item-title>
                            {{ $t("deleteSection") }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-list-item>
            </template>
            <draggable
              v-if="listItem.entity_type == 'section'"
              tag="v-list"
              class="areaInSection list-group pa-0"
              :list="listItem.tasks"
              :group="{
                name: 'g1',
                put(to, from) {
                  if (isSectionDragged == true) {
                    return false;
                  }
                  return true;
                },
              }"
              ghost-class="ghost-sub"
              :handle="mobile() ? '.handle' : ''"
              @end="onEndInSection"
              @change="onChangeInSection($event, listItem)"
              :move="onMove"
            >
              <v-list-item
                v-for="item in listItem.tasks"
                :key="item.id"
                data-testid="activity-page-item"
                router
                :class="{
                  'v-list-item--active':
                    $route.params.pageId == item.entity_id ||
                    $route.params.quizId == item.entity_id ||
                    $route.params.scormId == item.entity_id ||
                    $route.params.checklistId == item.entity_id ||
                    $route.params.surveyId == item.entity_id,
                }"
                class="menu_text pa-0"
                :ripple="false"
                @click="updateDrawerStateOnClickItem(item.entity_type)"
                @click.prevent="
                  item.entity_type == 'activity_page'
                    ? redirectToActivityPage(item.entity_id)
                    : item.entity_type == 'quiz'
                    ? redirectToActivityQuiz(item.entity_id)
                    : item.entity_type == 'scorm'
                    ? redirectToActivityScorm(item.entity_id)
                    : item.entity_type == 'checklist'
                    ? redirectToActivityChecklist(item.entity_id)
                    : item.entity_type == 'survey'
                    ? redirectToActivitySurvey(item.entity_id)
                    : ''
                "
                :dragid="item.id"
              >
                <v-row no-gutters class="custom-width">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-col
                        :cols="!item.edit ? 8 : 11"
                        class="text-no-wrap text-truncate d-flex"
                        v-on="on"
                      >
                        <v-icon
                          v-if="
                            item.entity_type == 'activity_page' ||
                            item.entity_type == 'scorm'
                          "
                          class="v-list-item__icon"
                        >
                          mdi-text
                        </v-icon>
                        <v-icon
                          v-if="item.entity_type == 'quiz'"
                          class="v-list-item__icon"
                        >
                          mdi-chat-question-outline
                        </v-icon>
                        <v-icon
                          v-if="item.entity_type == 'checklist'"
                          class="v-list-item__icon"
                        >
                          mdi-order-bool-ascending-variant
                        </v-icon>
                        <v-icon
                          v-if="item.entity_type == 'survey'"
                          class="v-list-item__icon"
                        >
                          mdi-help-box-multiple-outline
                        </v-icon>
                        <v-icon
                          v-if="
                            item.rule_item_id != null && sharingSettings != 3
                          "
                          color="warning"
                          class="v-list-item__icon"
                          dense
                        >
                          mdi-lightning-bolt-circle
                        </v-icon>
                        <v-icon
                          v-if="
                            item.rule_available_after != null &&
                            item.rule_fulfilled == false
                          "
                          color="warning"
                          class="v-list-item__icon"
                          dense
                        >
                          mdi-clock
                        </v-icon>
                        <span
                          v-if="!item.edit"
                          class="
                            title
                            text-truncate text-body-2
                            align-self-center
                          "
                        >
                          <v-chip
                            v-if="!item.is_published"
                            class="activity-feed-draft-tag"
                            data-testid="draft-available-chip"
                            color="warning"
                            text-color="black"
                            >{{ $t("draft") }}</v-chip
                          >
                          {{ item.title }}
                        </span>
                        <v-form
                          v-else
                          ref="form"
                          v-model="valid"
                          v-click-outside="onClickOutside"
                          class="d-flex align-self-end"
                          @submit.prevent
                          @keydown.enter.prevent
                        >
                          <v-text-field
                            v-model="item.title"
                            autofocus
                            data-testid="title-input"
                            class="mt-0 pt-0"
                            hide-details
                            :append-icon="valid ? 'mdi-check-bold' : ''"
                            :rules="titleRules"
                            @click:append="editTitle(item)"
                            @keydown.enter="editTitle(item)"
                            @click.stop.prevent
                            @keydown.enter.stop.prevent
                          />
                        </v-form>
                      </v-col>
                    </template>
                    <span>{{ item.title }}</span>
                  </v-tooltip>
                  <v-col
                    v-if="
                      listLiveUsers.find(
                        (user) => user.entity_id == item.entity_id
                      )
                    "
                    data-testid="editor-user"
                    cols="2"
                    class="text-center align-self-center"
                  >
                    <v-avatar
                      size="37"
                      :style="
                        `border:3px solid; color: #` +
                        intToRGB(
                          hashCode(
                            listLiveUsers.find(
                              (user) => user.entity_id == item.entity_id
                            ).first_name +
                              listLiveUsers.find(
                                (user) => user.entity_id == item.entity_id
                              ).last_name
                          )
                        )
                      "
                      class="avatar"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <img
                            v-if="
                              listLiveUsers.find(
                                (user) => user.entity_id == item.entity_id
                              ).avatar == null
                            "
                            src="../assets/user_images/profile-avatar.png"
                            v-on="on"
                          />
                          <img
                            v-else
                            :src="
                              listLiveUsers.find(
                                (user) => user.entity_id == item.entity_id
                              ).avatar
                            "
                            v-on="on"
                          />
                        </template>
                        <span
                          >{{
                            listLiveUsers.find(
                              (user) => user.entity_id == item.entity_id
                            ).first_name +
                            " " +
                            listLiveUsers.find(
                              (user) => user.entity_id == item.entity_id
                            ).last_name
                          }}
                          {{ $t("someoneIsEditing") }}</span
                        >
                      </v-tooltip>
                    </v-avatar>
                  </v-col>

                  <v-col
                    v-else
                    cols="2"
                    class="text-center align-self-center"
                  />
                  <v-col
                    v-if="!item.edit && isAuth && role == 'booster' && !mobile()"
                    cols="2"
                    class="text-right align-self-center"
                  >
                    <v-menu ref="menuRef" offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="dots-vertical"
                          icon
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon data-testid="threedots-icon">
                            mdi-dots-vertical
                          </v-icon>
                        </v-btn>
                      </template>
                      <v-list data-testid="menu-list">
                        <v-list-item
                          data-testid="edit-title-item"
                          router
                          @click.stop.prevent="showEditTitleField(item)"
                        >
                          <v-list-item-title>
                            {{ $t("editTitle") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-tooltip v-if="sharingSettings == 3" bottom>
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-list-item
                                data-testid="set-activity-rule"
                                :disabled="
                                  item.id == activityDefaultItemId ||
                                  item.is_published == false ||
                                  sharingSettings == 3 ||
                                  (productPlan.attributes &&
                                    productPlan.attributes.name == 'Free')
                                "
                                router
                                @click.stop="
                                  selectedActivityItem = item;
                                  (dialogVisibleSetRule =
                                    item.id == activityDefaultItemId ||
                                    item.is_published == false
                                      ? false
                                      : true),
                                    (confirmationDialogTitle = $t(
                                      'confirmationDialogTitleSetRule'
                                    )),
                                    (confirmationDialogSubmitBtn = $t('save'));
                                  confirmationDialogCancelBtn = $t('cancel');
                                "
                              >
                                <v-list-item-title v-on="on">
                                  {{ $t("rule") }}
                                  <v-chip
                                    v-if="
                                      productPlan.attributes &&
                                      productPlan.attributes.name == 'Free'
                                    "
                                    class="rounded-lg ml-2 px-2"
                                    x-small
                                    color="accent"
                                    text-color="white"
                                    >PRO</v-chip
                                  >
                                </v-list-item-title>
                              </v-list-item>
                            </div>
                          </template>
                          <span>{{
                            $t("rulesInOpenActivityNotApplicableTooltip")
                          }}</span>
                        </v-tooltip>
                        <v-list-item
                          v-else
                          data-testid="set-activity-rule"
                          :disabled="
                            item.id == activityDefaultItemId ||
                            item.is_published == false ||
                            sharingSettings == 3 ||
                            (productPlan.attributes &&
                              productPlan.attributes.name == 'Free')
                          "
                          router
                          @click.stop="
                            selectedActivityItem = item;
                            (dialogVisibleSetRule =
                              item.id == activityDefaultItemId ||
                              item.is_published == false
                                ? false
                                : true),
                              (confirmationDialogTitle = $t(
                                'confirmationDialogTitleSetRule'
                              )),
                              (confirmationDialogSubmitBtn = $t('save'));
                            confirmationDialogCancelBtn = $t('cancel');
                          "
                        >
                          <v-list-item-title
                            >{{ $t("rule") }}
                            <v-chip
                              v-if="
                                productPlan.attributes &&
                                productPlan.attributes.name == 'Free'
                              "
                              class="rounded-lg ml-2 px-2"
                              x-small
                              color="accent"
                              text-color="white"
                              >PRO</v-chip
                            >
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          data-testid="duplicate-draft-item"
                          router
                          :disabled="
                            item.is_published == true && item.has_draft == false
                          "
                          @click="duplicateDraftFeedItemActivity(item)"
                        >
                          <v-list-item-title>
                            {{ $t("duplicateDraftActivityFeedItem") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          data-testid="duplicate-published-item"
                          router
                          :disabled="item.is_published == false"
                          @click="duplicatePublishedFeedItemActivity(item)"
                        >
                          <v-list-item-title>
                            {{ $t("duplicatePublishedActivityFeedItem") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="
                            !item.edit && item.entity_type == 'activity_page'
                          "
                          data-testid="delete-activity-item-page"
                          :disabled="
                            listLiveUsers.some(
                              (user) => user.entity_id == item.entity_id
                            )
                          "
                          router
                          @click.stop="
                            selectedActivityFeedIdForDeletion = item.entity_id;
                            (dialogVisibleDelete = true),
                              (confirmationDialogTitle = $t(
                                'confirmationDialogTitleDeleteActivityPage'
                              )),
                              (confirmationDialogText = $t(
                                'confirmationDialogTextDeleteActivityPage'
                              )),
                              (confirmationDialogSubmitBtn = $t('delete'));
                            confirmationDialogCancelBtn = $t('no');
                            entityType='page'
                          "
                        >
                          <v-list-item-title>
                            {{ $t("delete") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="!item.edit && item.entity_type == 'quiz'"
                          data-testid="delete-activity-item-quiz"
                          :disabled="
                            listLiveUsers.some(
                              (user) => user.entity_id == item.entity_id
                            )
                          "
                          router
                          @click.stop="
                            selectedActivityFeedIdForDeletion = item.entity_id;
                            (dialogVisibleDelete = true),
                              (confirmationDialogTitle = $t(
                                'confirmationDialogTitleDeleteActivityQuiz'
                              )),
                              (confirmationDialogText = $t(
                                'confirmationDialogTextDeleteActivityQuiz'
                              )),
                              (confirmationDialogSubmitBtn = $t('delete'));
                            confirmationDialogCancelBtn = $t('no');
                            entityType='quiz'
                          "
                        >
                          <v-list-item-title>
                            {{ $t("delete") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="!item.edit && item.entity_type == 'scorm'"
                          data-testid="delete-activity-item-scorm"
                          :disabled="
                            listLiveUsers.some(
                              (user) => user.entity_id == item.entity_id
                            )
                          "
                          router
                          @click.stop="
                            selectedActivityFeedIdForDeletion = item.entity_id;
                            (dialogVisibleDelete = true),
                              (confirmationDialogTitle = $t(
                                'confirmationDialogTitleDeleteActivityScorm'
                              )),
                              (confirmationDialogText = $t(
                                'confirmationDialogTextDeleteActivityScorm'
                              )),
                              (confirmationDialogSubmitBtn = $t('delete'));
                            confirmationDialogCancelBtn = $t('no');
                            entityType='scorm'
                          "
                        >
                          <v-list-item-title>
                            {{ $t("delete") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="!item.edit && item.entity_type == 'checklist'"
                          data-testid="delete-activity-item-checklist"
                          :disabled="
                            listLiveUsers.some(
                              (user) => user.entity_id == item.entity_id
                            )
                          "
                          router
                          @click.stop="
                            selectedActivityFeedIdForDeletion =
                              item.entity_id;
                            (dialogVisibleDelete = true),
                              (confirmationDialogTitle = $t(
                                'confirmationDialogTitleDeleteActivityChecklist'
                              )),
                              (confirmationDialogText = $t(
                                'confirmationDialogTextDeleteActivityChecklist'
                              )),
                              (confirmationDialogSubmitBtn = $t('delete'));
                            confirmationDialogCancelBtn = $t('no');
                            entityType='checklist'
                          "
                        >
                          <v-list-item-title>
                            {{ $t("delete") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="!item.edit && item.entity_type == 'survey'"
                          data-testid="delete-activity-item-survey"
                          :disabled="
                            listLiveUsers.some(
                              (user) => user.entity_id == item.entity_id
                            )
                          "
                          router
                          @click.stop="
                            selectedActivityFeedIdForDeletion =
                              item.entity_id;
                            (dialogVisibleDelete = true),
                              (confirmationDialogTitle = $t(
                                'confirmationDialogTitleDeleteActivitySurvey'
                              )),
                              (confirmationDialogText = $t(
                                'confirmationDialogTextDeleteActivitySurvey'
                              )),
                              (confirmationDialogSubmitBtn = $t('delete'));
                            confirmationDialogCancelBtn = $t('no');
                            entityType='survey'
                          "
                        >
                          <v-list-item-title>
                            {{ $t("delete") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="!item.edit && item.entity_type == 'section'"
                          data-testid="delete-activity-item-section"
                          router
                          @click.stop="
                            selectedActivityFeedIdForDeletion =
                              item.entity_id;
                            (dialogVisibleDelete = true),
                              (confirmationDialogTitle = $t(
                                'confirmationDialogTitleDeleteActivitySection'
                              )),
                              (confirmationDialogText = $t(
                                'confirmationDialogTextDeleteActivitySection'
                              )),
                              (confirmationDialogSubmitBtn = $t('delete'));
                            confirmationDialogCancelBtn = $t('no');
                            entityType='section'
                          "
                        >
                          <v-list-item-title>
                            {{ $t("deleteSection") }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-list-item>
            </draggable>
          </v-list-group>
        </draggable>
        <div
          v-if="numberOfPages == 1 && role == 'booster'"
          class="mt-15 px-4"
          data-testid="activity-pages-note"
        >
          <span class="d-block warning--text"
            >{{ $t("activityPageFeedNoteTitle") }}:</span
          >{{ $t("activityPageFeedNoteText") }}
        </div>
        <div
          v-if="error && error != ''"
          class="mt-15 px-4"
          data-testid="activity-pages-error"
        >
          <span class="d-block error--text">{{ error }}</span>
        </div>

        <!--if role is not booster -->
        <div
          v-if="role != 'booster'"
          class="areaNavBar list-group mx-auto pb-16"
        >
          <v-list-group
            v-for="item in list"
            :key="item.id"
            v-model="item.active"
            no-action
            router
            :class="{
              'v-list-item--active':
                $route.params.pageId == item.entity_id ||
                $route.params.quizId == item.entity_id ||
                $route.params.scormId == item.entity_id ||
                $route.params.checklistId == item.entity_id ||
                $route.params.surveyId == item.entity_id,
              section: item.entity_type == 'section',
            }"
            color="anchor"
            class="menu_text pa-0 pl-0"
            :ripple="false"
            :prepend-icon="item.entity_type == 'section' ? '$expand' : ''"
            sub-group
            @click="updateDrawerStateOnClickItem(item.entity_type)"
            @click.prevent="
              item.entity_type == 'activity_page'
                ? redirectToActivityPage(item.entity_id)
                : item.entity_type == 'quiz'
                ? redirectToActivityQuiz(item.entity_id)
                : item.entity_type == 'scorm'
                ? redirectToActivityScorm(item.entity_id)
                : item.entity_type == 'checklist'
                ? redirectToActivityChecklist(item.entity_id)
                : item.entity_type == 'survey'
                ? redirectToActivitySurvey(item.entity_id)
                : ''
            "
          >
            <v-icon
              v-if="item.entity_type == 'section'"
              slot="prependIcon"
              class="section-icon"
              :class="{
                'warning--text': item.started == true && item.finished == false,
                'success--text': item.finished == true,
              }"
            >
              {{ "$expand" }}
            </v-icon>
            <template v-slot:activator>
              <v-list-item
                data-testid="activity-page-item"
                class="pa-0 activity-page-item"
                :class="{
                  'v-list-item--active':
                    $route.params.pageId == item.entity_id ||
                    $route.params.quizId == item.entity_id ||
                    $route.params.scormId == item.entity_id ||
                    $route.params.checklistId == item.entity_id ||
                    $route.params.surveyId == item.entity_id,
                }"
              >
                <v-row no-gutters>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-col
                        :cols="10"
                        class="text-no-wrap text-truncate d-flex"
                        v-on="on"
                      >
                        <v-icon
                          v-if="
                            item.entity_type == 'activity_page' ||
                            item.entity_type == 'scorm'
                          "
                          class="v-list-item__icon"
                          :class="{
                            'locked-content':
                              (item.rule_item_id != null &&
                              item.rule_fulfilled == false) || 
                              (item.rule_available_after != null && 
                              item.rule_fulfilled == false),
                            'warning--text':
                              item.started == true && item.finished == false,
                            'success--text': item.finished == true,
                          }"
                        >
                          mdi-text
                        </v-icon>
                        <v-icon
                          v-if="item.entity_type == 'quiz'"
                          class="v-list-item__icon"
                          :class="{
                            'locked-content':
                              (item.rule_item_id != null &&
                              item.rule_fulfilled == false) || 
                              (item.rule_available_after != null && 
                              item.rule_fulfilled == false),
                            'warning--text':
                              item.started == true && item.finished == false,
                            'success--text': item.finished == true,
                          }"
                        >
                          mdi-chat-question-outline
                        </v-icon>
                        <v-icon
                          v-if="item.entity_type == 'checklist'"
                          class="v-list-item__icon"
                          :class="{
                            'locked-content':
                              (item.rule_item_id != null &&
                              item.rule_fulfilled == false) || 
                              (item.rule_available_after != null && 
                              item.rule_fulfilled == false),
                            'warning--text':
                              item.started == true && item.finished == false,
                            'success--text': item.finished == true,
                          }"
                        >
                          mdi-order-bool-ascending-variant
                        </v-icon>
                        <v-icon
                          v-if="item.entity_type == 'survey'"
                          class="v-list-item__icon"
                          :class="{
                            'locked-content':
                              (item.rule_item_id != null &&
                              item.rule_fulfilled == false) || 
                              (item.rule_available_after != null && 
                              item.rule_fulfilled == false),
                            'warning--text':
                              item.started == true && item.finished == false,
                            'success--text': item.finished == true,
                          }"
                        >
                          mdi-help-box-multiple-outline
                        </v-icon>
                        <span
                          :class="{
                            'greytextlight--text':
                              (item.rule_item_id != null &&
                              item.rule_fulfilled == false)  || 
                              (item.rule_available_after != null && 
                              item.rule_fulfilled == false),
                            'warning--text':
                              item.started == true && item.finished == false,
                            'success--text': item.finished == true,
                          }"
                          class="
                            title
                            text-truncate text-body-2
                            align-self-center
                          "
                        >
                          {{ item.title }}
                        </span>
                      </v-col>
                    </template>
                    <span>{{ item.title }}</span>
                  </v-tooltip>
                </v-row>
              </v-list-item>
            </template>
            <div
              v-if="item.entity_type == 'section'"
              tag="v-list"
              class="areaInSection list-group pa-0"
            >
              <v-list-item
                v-for="itemInSection in item.tasks"
                :key="itemInSection.id"
                data-testid="activity-page-item"
                router
                :class="{
                  'v-list-item--active':
                    $route.params.pageId == itemInSection.entity_id ||
                    $route.params.quizId == itemInSection.entity_id ||
                    $route.params.scormId == itemInSection.entity_id ||
                    $route.params.checklistId == itemInSection.entity_id ||
                    $route.params.surveyId == itemInSection.entity_id,
                }"
                class="menu_text pa-0 activity-page-item"
                :ripple="false"
                @click="updateDrawerStateOnClickItem(itemInSection.entity_type)"
                @click.prevent="
                  itemInSection.entity_type == 'activity_page'
                    ? redirectToActivityPage(itemInSection.entity_id)
                    : itemInSection.entity_type == 'quiz'
                    ? redirectToActivityQuiz(itemInSection.entity_id)
                    : itemInSection.entity_type == 'scorm'
                    ? redirectToActivityScorm(itemInSection.entity_id)
                    : itemInSection.entity_type == 'checklist'
                    ? redirectToActivityChecklist(itemInSection.entity_id)
                    : itemInSection.entity_type == 'survey'
                    ? redirectToActivitySurvey(itemInSection.entity_id)
                    : ''
                "
              >
                <v-row no-gutters class="custom-width">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-col
                        :cols="10"
                        class="text-no-wrap text-truncate d-flex"
                        v-on="on"
                      >
                        <v-icon
                          v-if="
                            itemInSection.entity_type == 'activity_page' ||
                            itemInSection.entity_type == 'scorm'
                          "
                          class="v-list-item__icon"
                          :class="{
                            'locked-content':
                              (itemInSection.rule_item_id != null &&
                              itemInSection.rule_fulfilled == false) || 
                              (itemInSection.rule_available_after != null && 
                              itemInSection.rule_fulfilled == false),
                            'warning--text':
                              itemInSection.started == true &&
                              itemInSection.finished == false,
                            'success--text': itemInSection.finished == true,
                          }"
                        >
                          mdi-text
                        </v-icon>
                        <v-icon
                          v-if="itemInSection.entity_type == 'quiz'"
                          class="v-list-item__icon"
                          :class="{
                            'locked-content':
                              (itemInSection.rule_item_id != null &&
                              itemInSection.rule_fulfilled == false) || 
                              (itemInSection.rule_available_after != null && 
                              itemInSection.rule_fulfilled == false),
                            'warning--text':
                              itemInSection.started == true &&
                              itemInSection.finished == false,
                            'success--text': itemInSection.finished == true,
                          }"
                        >
                          mdi-chat-question-outline
                        </v-icon>
                        <v-icon
                          v-if="itemInSection.entity_type == 'checklist'"
                          class="v-list-item__icon"
                          :class="{
                            'locked-content':
                              (itemInSection.rule_item_id != null &&
                              itemInSection.rule_fulfilled == false) || 
                              (itemInSection.rule_available_after != null && 
                              itemInSection.rule_fulfilled == false),
                            'warning--text':
                              itemInSection.started == true &&
                              itemInSection.finished == false,
                            'success--text': itemInSection.finished == true,
                          }"
                        >
                          mdi-order-bool-ascending-variant
                        </v-icon>
                        <v-icon
                          v-if="itemInSection.entity_type == 'survey'"
                          class="v-list-item__icon"
                          :class="{
                            'locked-content':
                              (itemInSection.rule_item_id != null &&
                              itemInSection.rule_fulfilled == false) || 
                              (itemInSection.rule_available_after != null && 
                              itemInSection.rule_fulfilled == false),
                            'warning--text':
                              itemInSection.started == true &&
                              itemInSection.finished == false,
                            'success--text': itemInSection.finished == true,
                          }"
                        >
                          mdi-help-box-multiple-outline
                        </v-icon>
                        <span
                          :class="{
                            'greytextlight--text':
                              (itemInSection.rule_item_id != null &&
                              itemInSection.rule_fulfilled == false)  || 
                              (itemInSection.rule_available_after != null && 
                              itemInSection.rule_fulfilled == false),
                            'warning--text':
                              itemInSection.started == true &&
                              itemInSection.finished == false,
                            'success--text': itemInSection.finished == true,
                          }"
                          class="
                            title
                            text-truncate text-body-2
                            align-self-center
                          "
                        >
                          {{ itemInSection.title }}
                        </span>
                      </v-col>
                    </template>
                    <span>{{ itemInSection.title }}</span>
                  </v-tooltip>
                </v-row>
              </v-list-item>
            </div>
          </v-list-group>
        </div>
      </v-navigation-drawer>

      <ConfirmationDialog
        v-if="dialogVisibleDelete"
        ref="confirmationDialogDelete"
        :visible="dialogVisibleDelete"
        :cd-title="confirmationDialogTitle"
        :cd-text="confirmationDialogText"
        :cd-submit-btn="confirmationDialogSubmitBtn"
        :cd-cancel-btn="confirmationDialogCancelBtn"
        data-testid="confirmation-dialog-delete"
        @close="dialogVisibleDelete = false"
        @proceedSubmit="deleteEntity(selectedActivityFeedIdForDeletion)"
      />
      <ConfirmationDialogActivityItemRule
        v-if="dialogVisibleSetRule"
        ref="confirmationDialogSetRule"
        :visible="dialogVisibleSetRule"
        :cd-title="confirmationDialogTitle"
        :cd-submit-btn="confirmationDialogSubmitBtn"
        :cd-cancel-btn="confirmationDialogCancelBtn"
        :item="selectedActivityItem"
        :items="pages"
        data-testid="confirmation-dialog-set-rule"
        @close="dialogVisibleSetRule = false"
        @proceedSubmit="setActivityItemRule"
      />
      <InfoDialog
        v-if="dialogVisibleInfo"
        ref="infoDialog"
        :visible="dialogVisibleInfo"
        :cd-title="infoDialogTitle"
        :cd-text="infoDialogText"
        data-testid="info-dialog"
        @close="dialogVisibleInfo = false"
      />
    </div>
    <PlusButtonInActivity v-if="isAuth && role == 'booster' && !mobile()" />
  </nav>
</template>
<script>
import { eventBus } from "../eventbus";
import { ruleRequired, ruleValidMin2Max70Characters } from "../rules/formRules.js";
import Vue from "vue";
import {
  duplicateFeedItemActivity,
  getActivityPages,
  getActivity,
  reorderActivityFeedItems,
  deleteActivityPage,
  deleteActivityQuiz,
  deleteActivityScorm,
  deleteActivityChecklist,
  deleteActivitySection,
  updateActivityPage,
  updateActivitySection,
  updateActivityQuiz,
  updateActivityScorm,
  updateActivityChecklist,
  setActivityRule,
  updateActivitySurvey,
  deleteActivitySurvey
} from "../api/activityApi";
import i18n from "../plugins/i18n";
import ConfirmationDialog from "./ConfirmationDialog.vue";
import draggable from "vuedraggable";
import AlertMessages from "./AlertMessages";
import { repeatedMethodsMixin } from "../mixins/repeatedMethodsMixin";
import ConfirmationDialogActivityItemRule from "./ConfirmationDialogActivityItemRule.vue";
import InfoDialog from "./InfoDialog.vue";
import PlusButtonInActivity from "./PlusButtonInActivity.vue";
import moment from 'moment'

export default {
  components: {
    draggable,
    ConfirmationDialog,
    AlertMessages,
    ConfirmationDialogActivityItemRule,
    InfoDialog,
    PlusButtonInActivity
  },
  mixins: [repeatedMethodsMixin],
  data() {
    return {
      isAuth: window.$cookies.get("token") ? true : false,
      pages: [],
      valid: true,
      titleRules: ruleRequired('labelTitle').concat(ruleValidMin2Max70Characters('labelTitle')),
      activityId: this.$route.params.id,
      pageId: this.$route.params.pageId,
      quizId: this.$route.params.quizId,
      scormId: this.$route.params.scormId,
      checklistId: this.$route.params.checklistId,
      surveyId: this.$route.params.surveyId,
      error: "",
      dialogVisibleDelete: false,
      confirmationDialogTitle: "",
      confirmationDialogText: "",
      confirmationDialogCancelBtn: "",
      confirmationDialogSubmitBtn: "",
      selectedActivityFeedIdForDeletion: "",
      selectedActivitySurveyIdForDeletion: "",
      list: [],
      isSectionDragged: false,
      isDragging: false,
      listRequest: [],
      numberOfPages: 0,
      drawer: this.mobile() ? false : true,
      role: "",
      alertMsg: "",
      alertType: "",
      alertValue: false,
      loadingData: false,
      dialogVisibleSetRule: false,
      selectedActivityItem: {},
      activityDefaultItemId: null,
      dialogVisibleInfo: false,
      infoDialogTitle: "",
      infoDialogText: "",
      hasActivityAccess: false,
      sharingSettings: null,
      someoneEditing: false,
      avatar: localStorage.user
        ? JSON.parse(localStorage.user).avatar_thumb
        : null,
      liveUsers: [],
      dragOverId: null,
      entityType: 'page',
      subscriptionEnds: localStorage.space
        ? JSON.parse(localStorage.space).subscription_ends_at
        : "",
      completedPercentage: 0
        
    };
  },
  computed: {
    listLiveUsers() {
      return this.$store.state.list;
    },
    productPlan() {
      return this.$store.state.productPlan;
    },
  },

  watch: {
    productPlan: {
      immediate: true,
      handler(to) {
        if (to) {
          if (
            this.productPlan.attributes &&
            this.productPlan.attributes.name != "Free"
          ) {
            this.listen();
            this.getActivityEditors();
          }
        }
      },
    },
  },

  async created() {
    this.loadingData = true;
    await this.getActivity();
    if (this.hasActivityAccess) {
      await this.getActivityPages();
    }

    eventBus.$on("setSharingSettings", (settings) => {
      this.sharingSettings = settings;
    });

    //listening for the custom event
    eventBus.$on("changeNavigationInActivity", (links) => {
      //if(JSON.stringify(links) !== JSON.stringify(this.pages)){
      var count = 0;
      this.pages = links;
      if (
        this.pages.filter(
          (page) =>
            page.attributes.entity_type != "section" &&
            page.attributes.is_published == true
        ).length > 0
      ) {
        this.activityDefaultItemId = this.pages.filter(
          (page) =>
            page.attributes.entity_type != "section" &&
            page.attributes.is_published == true
        )[0].id;
      }
      this.filteredActiveSections = this.list.filter(
        (section) => section.active == true
      );
      this.list = [];
      for (let i = 0; i < this.pages.length; i++) {
        if (this.pages[i].attributes.section_id == null) {
          if (
            this.filteredActiveSections.find(
              ({ entity_id }) =>
                entity_id === this.pages[i].attributes.entity_id
            )
          ) {
            this.list.push({
              id: this.pages[i].id,
              title: this.pages[i].attributes.title,
              entity_type: this.pages[i].attributes.entity_type,
              entity_id: this.pages[i].attributes.entity_id,
              position: this.pages[i].attributes.position,
              section_id: this.pages[i].attributes.section_id,
              has_draft: this.pages[i].attributes.has_draft,
              is_published: this.pages[i].attributes.is_published,
              tasks: [],
              active: true,
              rule_available_after: this.pages[i].attributes.rule_available_after,
              rule_item_id: this.pages[i].attributes.rule_item_id,
              rule_fulfilled: this.pages[i].attributes.rule_fulfilled,
              started: this.pages[i].attributes.started,
              finished: this.pages[i].attributes.finished,
            });
          } else {
            this.list.push({
              id: this.pages[i].id,
              title: this.pages[i].attributes.title,
              entity_type: this.pages[i].attributes.entity_type,
              entity_id: this.pages[i].attributes.entity_id,
              position: this.pages[i].attributes.position,
              section_id: this.pages[i].attributes.section_id,
              has_draft: this.pages[i].attributes.has_draft,
              is_published: this.pages[i].attributes.is_published,
              tasks: [],
              active: false,
              rule_available_after: this.pages[i].attributes.rule_available_after,
              rule_item_id: this.pages[i].attributes.rule_item_id,
              rule_fulfilled: this.pages[i].attributes.rule_fulfilled,
              started: this.pages[i].attributes.started,
              finished: this.pages[i].attributes.finished,
            });
          }
        } else {
          let nestedSection = this.list.find(
            ({ entity_id }) => entity_id === this.pages[i].attributes.section_id
          );
          nestedSection.tasks.push({
            id: this.pages[i].id,
            title: this.pages[i].attributes.title,
            entity_type: this.pages[i].attributes.entity_type,
            entity_id: this.pages[i].attributes.entity_id,
            position: this.pages[i].attributes.position,
            section_id: this.pages[i].attributes.section_id,
            has_draft: this.pages[i].attributes.has_draft,
            is_published: this.pages[i].attributes.is_published,
            tasks: [],
            active: false,
            rule_available_after: this.pages[i].attributes.rule_available_after,
            rule_item_id: this.pages[i].attributes.rule_item_id,
            rule_fulfilled: this.pages[i].attributes.rule_fulfilled,
            started: this.pages[i].attributes.started,
            finished: this.pages[i].attributes.finished,
          });
        }
      }

      for (var i = 0; i < this.pages.length; i++) {
        if (
          this.pages[i].attributes.entity_type == "activity_page" ||
          this.pages[i].attributes.entity_type == "quiz" ||
          this.pages[i].attributes.entity_type == "scorm" ||
          this.pages[i].attributes.entity_type == "checklist" ||
          this.pages[i].attributes.entity_type == "survey"
        ) {
          count++;
          this.numberOfPages = count;
        }
        if (!this.mobile()) {
          if (this.numberOfPages > 1) {
            this.drawer = true;
          } else {
            this.drawer = false;
          }
        }
      }
      this.numberOfPages = count;
      var cookie = window.$cookies.isKey(
        "activity-feed-state-" + this.$route.params.id
      );
      if (cookie || (cookie && this.numberOfPages > 1)) {
        this.drawer =
          window.$cookies.get(
            "activity-feed-state-" + this.$route.params.id
          ) === "true"
            ? window.$cookies.get(
                "activity-feed-state-" + this.$route.params.id
              ) === "true"
            : false;
      }

      if (this.role != "booster") {
        //remove empty sections for non booster users
        //set color of the section (not started, started, finished)
        var sections = this.pages.filter(
          (page) => page.attributes.entity_type == "section"
        );

        for (let i = 0; i < sections.length; i++) {
          var nestedTasks = this.list.find(
            (item) => item.id === sections[i].id
          ).tasks;
          if (nestedTasks.length > 0) {
            //if all are finished
            if (nestedTasks.every((e) => e.finished == true)) {
              this.list.find(
                (item) => item.id === sections[i].id
              ).started = true;
              this.list.find(
                (item) => item.id === sections[i].id
              ).finished = true;
            } else {
              //if at least one is started
              if (nestedTasks.some((e) => e.started == true)) {
                this.list.find(
                  (item) => item.id === sections[i].id
                ).started = true;
                this.list.find(
                  (item) => item.id === sections[i].id
                ).finished = false;
              }
            }
          } else {
            this.list = this.list.filter(
              (section) => section.id != sections[i].id
            );
          }
        }
      }
      //}
    });
    if (!this.mobile()) {
      var cookie = window.$cookies.isKey(
        "activity-feed-state-" + this.$route.params.id
      );
      if (cookie || (cookie && this.numberOfPages > 1)) {
        this.drawer =
          window.$cookies.get(
            "activity-feed-state-" + this.$route.params.id
          ) === "true"
            ? window.$cookies.get(
                "activity-feed-state-" + this.$route.params.id
              ) === "true"
            : false;
      }
    }

    /* eslint-disable no-unused-vars */
    eventBus.$on('checkUpdates',async (completedItem, certificate)=>{
        if(completedItem){
          const response = await getActivity(this.activityId);
          if (response.status == 200) {
            this.completedPercentage = response.data.data.meta.statistics.data.percentage
          }
        }
    }),
    /* eslint-enable no-unused-vars */

    this.loadingData = false;
  },
  beforeDestroy() {
    window.Echo.leave("feed-tracker." + this.activityId)
    eventBus.$off("setSharingSettings");
    eventBus.$off("changeNavigationInActivity");
    eventBus.$off('checkUpdates')
  },
  methods: {
    listen() {
      window.Echo.private("feed-tracker." + this.activityId).listen(
        "FeedEditingUpdated",
        () => {
          this.getActivityEditors();
        }
      );
    },

    getActivityEditors() {
      this.$store.dispatch("getActivityEditors", this.activityId);
    },

    deleteEntity(id){
        if(this.entityType == 'section'){
            this.deleteActivitySection(id)
        }else if(this.entityType == 'page'){
            this.deleteActivityPage(id)
        }else if(this.entityType == 'checklist'){
            this.deleteActivityChecklist(id)
        }else if(this.entityType == 'quiz'){
            this.deleteActivityQuiz(id)
        }else if(this.entityType == 'scorm'){
            this.deleteActivityScorm(id)
        }else {
          this.deleteActivitySurvey(id)
        }
    },

    async getActivity() {
      try {
        const response = await getActivity(this.activityId);
        if (response.status == 200) {
          this.hasActivityAccess = true;
          this.role = response.data.data.attributes.role;
          this.sharingSettings =
            response.data.data.relationships["sharing-setting"].data.id;
          this.completedPercentage = response.data.data.meta.statistics.data.percentage
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status != 401) {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }
    },
    async getActivityPages() {
      try {
        const response = await getActivityPages(this.activityId);
        if (response.status == 200) {
          var count = 0;
          this.list = [];
          if (this.role != "booster") {
            this.pages = response.data.data.filter(
              (page) => page.attributes.is_published == true
            );
          } else {
            this.pages = response.data.data;
          }

          if (
            this.pages.filter(
              (page) =>
                page.attributes.entity_type != "section" &&
                page.attributes.is_published == true
            ).length > 0
          ) {
            this.activityDefaultItemId = this.pages.filter(
              (page) =>
                page.attributes.entity_type != "section" &&
                page.attributes.is_published == true
            )[0].id;
          }
          for (let i = 0; i < this.pages.length; i++) {
            if (this.pages[i].attributes.section_id == null) {
              this.list.push({
                id: this.pages[i].id,
                title: this.pages[i].attributes.title,
                entity_type: this.pages[i].attributes.entity_type,
                entity_id: this.pages[i].attributes.entity_id,
                position: this.pages[i].attributes.position,
                section_id: this.pages[i].attributes.section_id,
                has_draft: this.pages[i].attributes.has_draft,
                is_published: this.pages[i].attributes.is_published,
                tasks: [],
                active: false,
                rule_available_after: this.pages[i].attributes.rule_available_after,
                rule_item_id: this.pages[i].attributes.rule_item_id,
                rule_fulfilled: this.pages[i].attributes.rule_fulfilled,
                started: this.pages[i].attributes.started,
                finished: this.pages[i].attributes.finished,
              });
            } else {
              let nestedSection = this.list.find(
                ({ entity_id }) =>
                  entity_id === this.pages[i].attributes.section_id
              );
              nestedSection.tasks.push({
                id: this.pages[i].id,
                title: this.pages[i].attributes.title,
                entity_type: this.pages[i].attributes.entity_type,
                entity_id: this.pages[i].attributes.entity_id,
                position: this.pages[i].attributes.position,
                section_id: this.pages[i].attributes.section_id,
                has_draft: this.pages[i].attributes.has_draft,
                is_published: this.pages[i].attributes.is_published,
                tasks: [],
                active: false,
                rule_available_after: this.pages[i].attributes.rule_available_after,
                rule_item_id: this.pages[i].attributes.rule_item_id,
                rule_fulfilled: this.pages[i].attributes.rule_fulfilled,
                started: this.pages[i].attributes.started,
                finished: this.pages[i].attributes.finished,
              });
            }
          }
        }

        for (var i = 0; i < this.pages.length; i++) {
          if (
            this.pages[i].attributes.entity_type == "activity_page" ||
            this.pages[i].attributes.entity_type == "quiz" ||
            this.pages[i].attributes.entity_type == "scorm" ||
            this.pages[i].attributes.entity_type == "checklist" ||
            this.pages[i].attributes.entity_type == "survey"
          ) {
            count++;
            this.numberOfPages = count;
          }
          if (!this.mobile()) {
            if (this.numberOfPages > 1) {
              this.drawer = true;
            } else {
              this.drawer = false;
            }
          }
        }

        this.numberOfPages = count;
        var cookie = window.$cookies.isKey(
          "activity-feed-state-" + this.$route.params.id
        );
        if (cookie || (cookie && this.numberOfPages > 1)) {
          this.drawer =
            window.$cookies.get(
              "activity-feed-state-" + this.$route.params.id
            ) === "true"
              ? window.$cookies.get(
                  "activity-feed-state-" + this.$route.params.id
                ) === "true"
              : false;
        }

        if (this.role != "booster") {
          //remove empty sections for non booster users
          //set color of the section (not started, started, finished)
          var sections = this.pages.filter(
            (page) => page.attributes.entity_type == "section"
          );

          for (let i = 0; i < sections.length; i++) {
            var nestedTasks = this.list.find(
              (item) => item.id === sections[i].id
            ).tasks;
            if (nestedTasks.length > 0) {
              //if all are finished
              if (nestedTasks.every((e) => e.finished == true)) {
                this.list.find(
                  (item) => item.id === sections[i].id
                ).started = true;
                this.list.find(
                  (item) => item.id === sections[i].id
                ).finished = true;
              } else {
                //if at least one is started
                if (nestedTasks.some((e) => e.started == true)) {
                  this.list.find(
                    (item) => item.id === sections[i].id
                  ).started = true;
                  this.list.find(
                    (item) => item.id === sections[i].id
                  ).finished = false;
                }
              }
            } else {
              this.list = this.list.filter(
                (section) => section.id != sections[i].id
              );
            }
          }
        }
      } catch (e) {
        if (e.response) {
          this.error = i18n.t("dataNotRetrievedError");
        }
      }
    },
    updateDrawerState() {
      if (this.mobile()) {
        this.drawer = !this.drawer;
      } else {
        this.drawer = !this.drawer;
        window.$cookies.set(
          "activity-feed-state-" + this.$route.params.id,
          this.drawer,
          0,
          null,
          process.env.VUE_APP_DOMAIN
        );
      }
    },
    updateDrawerStateOnClickItem(type) {
      if (this.mobile() && type != 'section') {
        this.drawer = false;
      }
    },
    async deleteActivityPage(item) {
      try {
        const response = await deleteActivityPage(item);
        if (response.status == 204) {
          await this.getActivityPages();
          if (item != this.$route.params.pageId) {
            this.alertMsg = i18n.t("deleteActivityPageSuccess");
            this.alertType = "success";
            this.alertValue = true;
          } else {
            this.filteredPages = this.pages.filter(
              (page) => !page.attributes.entity_type.includes("section")
            );
            var first_type = this.filteredPages[0].attributes.entity_type;
            var first = this.filteredPages[0].attributes.entity_id;
            if (first_type == "activity_page") {
              this.$router.push({
                name: "ViewActivityPage",
                params: {
                  id: this.$route.params.id,
                  pageId: first,
                  successfullyDeletedActivityPage: true,
                },
              });
            } else if (first_type == "scorm") {
              this.$router.push({
                name: "ViewActivityScorm",
                params: {
                  id: this.$route.params.id,
                  scormId: first,
                  successfullyDeletedActivityPage: true,
                },
              });
            } else if (first_type == "quiz") {
              this.$router.push({
                name: "ViewActivityQuiz",
                params: {
                  id: this.$route.params.id,
                  quizId: first,
                  successfullyDeletedActivityPage: true,
                },
              });
            } else if (first_type == "checklist") {
              this.$router.push({
                name: "ViewActivityChecklist",
                params: {
                  id: this.$route.params.id,
                  checklistId: first,
                  successfullyDeletedActivityPage: true,
                },
              });
            } else {
              this.$router.push({
                name: "ViewActivitySurvey",
                params: {
                  id: this.$route.params.id,
                  surveyId: first,
                  successfullyDeletedActivityPage: true,
                },
              });
            }
          }
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 403) {
            for (let i = 0; i < e.response.data.errors.length; i++) {
              if (
                e.response.data.errors[i].detail ==
                "This action is unauthorized."
              ) {
                this.$router.push({ name: "PageAccessDenied" });
              } else {
                this.alertValue = true;
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
              }
            }
          } else if (e.response.status == 422) {
            for (let i = 0; i < e.response.data.errors.length; i++) {
              if (e.response.data.errors[i].detail.includes("Next feed item")) {
                this.dialogVisibleInfo = true;
                this.infoDialogTitle = i18n.t("infoDialogPreventDeleteTitle");
                this.infoDialogText = i18n.t("infoDialogPreventDeleteText", {
                  title: e.response.data.errors[i].detail
                    .split("[")
                    .pop()
                    .split("]")[0],
                });
              } else {
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
                this.$emit(
                  "proceedSubmit",
                  this.alertMsg,
                  this.alertType,
                  this.name,
                  this.targetGroupIndex
                );
                this.reloadForm();
              }
            }
          } else {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }
      this.dialogVisibleDelete = false;
    },
    async deleteActivityQuiz(item) {
      try {
        const response = await deleteActivityQuiz(item);
        if (response.status == 204) {
          await this.getActivityPages();
          if (item != this.$route.params.quizId) {
            this.alertMsg = i18n.t("deleteActivityQuizSuccess");
            this.alertType = "success";
            this.alertValue = true;
          } else {
            this.filteredPages = this.pages.filter(
              (page) => !page.attributes.entity_type.includes("section")
            );
            var first_type = this.filteredPages[0].attributes.entity_type;
            var first = this.filteredPages[0].attributes.entity_id;
            if (first_type == "activity_page") {
              this.$router.push({
                name: "ViewActivityPage",
                params: {
                  id: this.$route.params.id,
                  pageId: first,
                  successfullyDeletedActivityQuiz: true,
                },
              });
            } else if (first_type == "scorm") {
              this.$router.push({
                name: "ViewActivityScorm",
                params: {
                  id: this.$route.params.id,
                  scormId: first,
                  successfullyDeletedActivityQuiz: true,
                },
              });
            } else if (first_type == "quiz") {
              this.$router.push({
                name: "ViewActivityQuiz",
                params: {
                  id: this.$route.params.id,
                  quizId: first,
                  successfullyDeletedActivityQuiz: true,
                },
              });
            } else if (first_type == "checklist") {
              this.$router.push({
                name: "ViewActivityChecklist",
                params: {
                  id: this.$route.params.id,
                  checklistId: first,
                  successfullyDeletedActivityQuiz: true,
                },
              });
            }else {
              this.$router.push({
                name: "ViewActivitySurvey",
                params: {
                  id: this.$route.params.id,
                  surveyId: first,
                  successfullyDeletedActivityQuiz: true,
                },
              });
            }
          }
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 403) {
            for (let i = 0; i < e.response.data.errors.length; i++) {
              if (
                e.response.data.errors[i].detail ==
                "This action is unauthorized."
              ) {
                this.$router.push({ name: "PageAccessDenied" });
              } else {
                this.alertValue = true;
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
              }
            }
          } else if (e.response.status == 422) {
            for (let i = 0; i < e.response.data.errors.length; i++) {
              if (e.response.data.errors[i].detail.includes("Next feed item")) {
                this.dialogVisibleInfo = true;
                this.infoDialogTitle = i18n.t("infoDialogPreventDeleteTitle");
                this.infoDialogText = i18n.t("infoDialogPreventDeleteText", {
                  title: e.response.data.errors[i].detail
                    .split("[")
                    .pop()
                    .split("]")[0],
                });
              } else {
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
                this.$emit(
                  "proceedSubmit",
                  this.alertMsg,
                  this.alertType,
                  this.name,
                  this.targetGroupIndex
                );
                this.reloadForm();
              }
            }
          } else {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }
      this.dialogVisibleDelete = false;
    },
    async deleteActivityScorm(item) {
      try {
        const response = await deleteActivityScorm(item);
        if (response.status == 204) {
          await this.getActivityPages();
          if (item != this.$route.params.scormId) {
            this.alertMsg = i18n.t("deleteActivityScormSuccess");
            this.alertType = "success";
            this.alertValue = true;
          } else {
            this.filteredPages = this.pages.filter(
              (page) => !page.attributes.entity_type.includes("section")
            );
            var first_type = this.filteredPages[0].attributes.entity_type;
            var first = this.filteredPages[0].attributes.entity_id;
            if (first_type == "activity_page") {
              this.$router.push({
                name: "ViewActivityPage",
                params: {
                  id: this.$route.params.id,
                  pageId: first,
                  successfullyDeletedActivityScorm: true,
                },
              });
            } else if (first_type == "quiz") {
              this.$router.push({
                name: "ViewActivityQuiz",
                params: {
                  id: this.$route.params.id,
                  quizId: first,
                  successfullyDeletedActivityScorm: true,
                },
              });
            } else if (first_type == "scorm") {
              this.$router.push({
                name: "ViewActivityScorm",
                params: {
                  id: this.$route.params.id,
                  scormId: first,
                  successfullyDeletedActivityScorm: true,
                },
              });
            } else if (first_type == "checklist") {
              this.$router.push({
                name: "ViewActivityChecklist",
                params: {
                  id: this.$route.params.id,
                  checklistId: first,
                  successfullyDeletedActivityScorm: true,
                },
              });
            }else {
              this.$router.push({
                name: "ViewActivitySurvey",
                params: {
                  id: this.$route.params.id,
                  surveyId: first,
                  successfullyDeletedActivityScorm: true,
                },
              });
            }
          }
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 403) {
            for (let i = 0; i < e.response.data.errors.length; i++) {
              if (
                e.response.data.errors[i].detail ==
                "This action is unauthorized."
              ) {
                this.$router.push({ name: "PageAccessDenied" });
              } else {
                this.alertValue = true;
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
              }
            }
          } else if (e.response.status == 422) {
            for (let i = 0; i < e.response.data.errors.length; i++) {
              if (e.response.data.errors[i].detail.includes("Next feed item")) {
                this.dialogVisibleInfo = true;
                this.infoDialogTitle = i18n.t("infoDialogPreventDeleteTitle");
                this.infoDialogText = i18n.t("infoDialogPreventDeleteText", {
                  title: e.response.data.errors[i].detail
                    .split("[")
                    .pop()
                    .split("]")[0],
                });
              } else {
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
                this.$emit(
                  "proceedSubmit",
                  this.alertMsg,
                  this.alertType,
                  this.name,
                  this.targetGroupIndex
                );
                this.reloadForm();
              }
            }
          } else {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }
      this.dialogVisibleDelete = false;
    },
    async deleteActivityChecklist(item) {
      try {
        const response = await deleteActivityChecklist(item);
        if (response.status == 204) {
          await this.getActivityPages();
          if (item != this.$route.params.checklistId) {
            this.alertMsg = i18n.t("deleteActivityChecklistSuccess");
            this.alertType = "success";
            this.alertValue = true;
          } else {
            this.filteredPages = this.pages.filter(
              (page) => !page.attributes.entity_type.includes("section")
            );
            var first_type = this.filteredPages[0].attributes.entity_type;
            var first = this.filteredPages[0].attributes.entity_id;
            if (first_type == "activity_page") {
              this.$router.push({
                name: "ViewActivityPage",
                params: {
                  id: this.$route.params.id,
                  pageId: first,
                  successfullyDeletedActivityChecklist: true,
                },
              });
            } else if (first_type == "quiz") {
              this.$router.push({
                name: "ViewActivityQuiz",
                params: {
                  id: this.$route.params.id,
                  quizId: first,
                  successfullyDeletedActivityChecklist: true,
                },
              });
            } else if (first_type == "scorm") {
              this.$router.push({
                name: "ViewActivityScorm",
                params: {
                  id: this.$route.params.id,
                  scormId: first,
                  successfullyDeletedActivityChecklist: true,
                },
              });
            } else if (first_type == "checklist") {
              this.$router.push({
                name: "ViewActivityChecklist",
                params: {
                  id: this.$route.params.id,
                  checklistId: first,
                  successfullyDeletedActivityChecklist: true,
                },
              });
            }else {
              this.$router.push({
                name: "ViewActivitySurvey",
                params: {
                  id: this.$route.params.id,
                  surveyId: first,
                  successfullyDeletedActivityChecklist: true,
                },
              });
            }
          }
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 403) {
            for (let i = 0; i < e.response.data.errors.length; i++) {
              if (
                e.response.data.errors[i].detail ==
                "This action is unauthorized."
              ) {
                this.$router.push({ name: "PageAccessDenied" });
              } else {
                this.alertValue = true;
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
              }
            }
          } else if (e.response.status == 422) {
            for (let i = 0; i < e.response.data.errors.length; i++) {
              if (e.response.data.errors[i].detail.includes("Next feed item")) {
                this.dialogVisibleInfo = true;
                this.infoDialogTitle = i18n.t("infoDialogPreventDeleteTitle");
                this.infoDialogText = i18n.t("infoDialogPreventDeleteText", {
                  title: e.response.data.errors[i].detail
                    .split("[")
                    .pop()
                    .split("]")[0],
                });
              } else {
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
                this.$emit(
                  "proceedSubmit",
                  this.alertMsg,
                  this.alertType,
                  this.name,
                  this.targetGroupIndex
                );
                this.reloadForm();
              }
            }
          } else {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }
      this.dialogVisibleDelete = false;
    },

    async deleteActivitySurvey(item) {
      try {
        const response = await deleteActivitySurvey(item);
        if (response.status == 204) {
          await this.getActivityPages();
          if (item != this.$route.params.surveyId) {
            this.alertMsg = i18n.t("deleteActivitySurveySuccess");
            this.alertType = "success";
            this.alertValue = true;
          } else {
            this.filteredPages = this.pages.filter(
              (page) => !page.attributes.entity_type.includes("section")
            );
            var first_type = this.filteredPages[0].attributes.entity_type;
            var first = this.filteredPages[0].attributes.entity_id;
            if (first_type == "activity_page") {
              this.$router.push({
                name: "ViewActivityPage",
                params: {
                  id: this.$route.params.id,
                  pageId: first,
                  successfullyDeletedActivitySurvey: true,
                },
              });
            } else if (first_type == "quiz") {
              this.$router.push({
                name: "ViewActivityQuiz",
                params: {
                  id: this.$route.params.id,
                  quizId: first,
                  successfullyDeletedActivitySurvey: true,
                },
              });
            } else if (first_type == "scorm") {
              this.$router.push({
                name: "ViewActivityScorm",
                params: {
                  id: this.$route.params.id,
                  scormId: first,
                  successfullyDeletedActivitySurvey: true,
                },
              });
            } else if (first_type == "checklist") {
              this.$router.push({
                name: "ViewActivityChecklist",
                params: {
                  id: this.$route.params.id,
                  checklistId: first,
                  successfullyDeletedActivitySurvey: true,
                },
              });
            }else {
              this.$router.push({
                name: "ViewActivitySurvey",
                params: {
                  id: this.$route.params.id,
                  surveyId: first,
                  successfullyDeletedActivitySurvey: true,
                },
              });
            }
          }
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 403) {
            for (let i = 0; i < e.response.data.errors.length; i++) {
              if (
                e.response.data.errors[i].detail ==
                "This action is unauthorized."
              ) {
                this.$router.push({ name: "PageAccessDenied" });
              } else {
                this.alertValue = true;
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
              }
            }
          } else if (e.response.status == 422) {
            for (let i = 0; i < e.response.data.errors.length; i++) {
              if (e.response.data.errors[i].detail.includes("Next feed item")) {
                this.dialogVisibleInfo = true;
                this.infoDialogTitle = i18n.t("infoDialogPreventDeleteTitle");
                this.infoDialogText = i18n.t("infoDialogPreventDeleteText", {
                  title: e.response.data.errors[i].detail
                    .split("[")
                    .pop()
                    .split("]")[0],
                });
              } else {
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
                this.$emit(
                  "proceedSubmit",
                  this.alertMsg,
                  this.alertType,
                  this.name,
                  this.targetGroupIndex
                );
                this.reloadForm();
              }
            }
          } else {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }
      this.dialogVisibleDelete = false;
    },

    async deleteActivitySection(item) {
      try {
        const response = await deleteActivitySection(item);
        if (response.status == 204) {
          await this.getActivityPages();
          this.alertMsg = i18n.t("deleteActivitySectionSuccess");
          this.alertType = "success";
          this.alertValue = true;
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 403) {
            for (let i = 0; i < e.response.data.errors.length; i++) {
              if (
                e.response.data.errors[i].detail ==
                "This action is unauthorized."
              ) {
                this.$router.push({ name: "PageAccessDenied" });
              } else {
                this.alertValue = true;
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
              }
            }
          } else {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }
      this.dialogVisibleDelete = false;
    },
    async editTitle(item) {
      if (this.valid) {
        Vue.set(item, "edit", !item.edit);
        if (item.entity_type == "activity_page") {
          let data = {
            data: {
              type: "activity-pages",
              id: item.entity_id,
              attributes: {
                title: item.title.trim(),
              },
              relationships: {
                activity: {
                  data: {
                    type: "activities",
                    id: this.$route.params.id,
                  },
                },
              },
            },
          };
          try {
            const response = await updateActivityPage(data.data.id, data);
            if (response.status == 200) {
              //updated - do not show anything
            }
          } catch (e) {
            if (e.response) {
              if (e.response.status == 403) {
                for (let i = 0; i < e.response.data.errors.length; i++) {
                  if (
                    e.response.data.errors[i].detail ==
                    "This action is unauthorized."
                  ) {
                    this.$router.push({ name: "PageAccessDenied" });
                  } else {
                    this.alertValue = true;
                    this.alertType = "error";
                    this.alertMsg = i18n.t("serverError");
                  }
                }
              } else {
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
                this.alertValue = true;
              }
            }
          }
        } else if (item.entity_type == "quiz") {
          let data = {
            data: {
              type: "quizzes",
              id: item.entity_id,
              attributes: {
                title: item.title.trim(),
              },
              relationships: {
                activity: {
                  data: {
                    type: "activities",
                    id: this.$route.params.id,
                  },
                },
              },
            },
          };
          try {
            const response = await updateActivityQuiz(data.data.id, data);
            if (response.status == 200) {
              //updated - do not show anything
            }
          } catch (e) {
            if (e.response) {
              if (e.response.status == 403) {
                for (let i = 0; i < e.response.data.errors.length; i++) {
                  if (
                    e.response.data.errors[i].detail ==
                    "This action is unauthorized."
                  ) {
                    this.$router.push({ name: "PageAccessDenied" });
                  } else {
                    this.alertValue = true;
                    this.alertType = "error";
                    this.alertMsg = i18n.t("serverError");
                  }
                }
              } else {
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
                this.alertValue = true;
              }
            }
          }
        } else if (item.entity_type == "scorm") {
          let data = {
            data: {
              type: "scorms",
              id: item.entity_id,
              attributes: {
                title: item.title.trim(),
              },
              relationships: {
                activity: {
                  data: {
                    type: "activities",
                    id: this.$route.params.id,
                  },
                },
              },
            },
          };
          try {
            const response = await updateActivityScorm(data.data.id, data);
            if (response.status == 200) {
              //updated - do not show anything
            }
          } catch (e) {
            if (e.response) {
              if (e.response.status == 403) {
                for (let i = 0; i < e.response.data.errors.length; i++) {
                  if (
                    e.response.data.errors[i].detail ==
                    "This action is unauthorized."
                  ) {
                    this.$router.push({ name: "PageAccessDenied" });
                  } else {
                    this.alertValue = true;
                    this.alertType = "error";
                    this.alertMsg = i18n.t("serverError");
                  }
                }
              } else {
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
                this.alertValue = true;
              }
            }
          }
        } else if (item.entity_type == "checklist") {
          let data = {
            data: {
              type: "checklists",
              id: item.entity_id,
              attributes: {
                title: item.title.trim(),
              },
              relationships: {
                activity: {
                  data: {
                    type: "activities",
                    id: this.$route.params.id,
                  },
                },
              },
            },
          };
          try {
            const response = await updateActivityChecklist(data.data.id, data);
            if (response.status == 200) {
              //updated - do not show anything
            }
          } catch (e) {
            if (e.response) {
              if (e.response.status == 403) {
                for (let i = 0; i < e.response.data.errors.length; i++) {
                  if (
                    e.response.data.errors[i].detail ==
                    "This action is unauthorized."
                  ) {
                    this.$router.push({ name: "PageAccessDenied" });
                  } else {
                    this.alertValue = true;
                    this.alertType = "error";
                    this.alertMsg = i18n.t("serverError");
                  }
                }
              } else {
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
                this.alertValue = true;
              }
            }
          }
        } else if (item.entity_type == "survey") {
          let data = {
            data: {
              type: "surveys",
              id: item.entity_id,
              attributes: {
                title: item.title.trim()
              },
              relationships: {
                activity: {
                  data: {
                    type: "activities",
                    id: this.$route.params.id,
                  },
                },
              },
            },
          };
          try {
            const response = await updateActivitySurvey(data.data.id, data);
            if (response.status == 200) {
              //updated - do not show anything
            }
          } catch (e) {
            if (e.response) {
              if (e.response.status == 403) {
                for (let i = 0; i < e.response.data.errors.length; i++) {
                  if (
                    e.response.data.errors[i].detail ==
                    "This action is unauthorized."
                  ) {
                    this.$router.push({ name: "PageAccessDenied" });
                  } else {
                    this.alertValue = true;
                    this.alertType = "error";
                    this.alertMsg = i18n.t("serverError");
                  }
                }
              } else {
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
                this.alertValue = true;
              }
            }
          }
        } else {
          let data = {
            data: {
              type: "sections",
              id: String(item.entity_id),
              attributes: {
                title: item.title.trim(),
              },
              relationships: {
                activity: {
                  data: {
                    type: "activities",
                    id: this.$route.params.id,
                  },
                },
              },
            },
          };
          try {
            const response = await updateActivitySection(data.data.id, data);
            if (response.status == 200) {
              //updated - do not show anything
            }
          } catch (e) {
            if (e.response) {
              if (e.response.status == 403) {
                for (let i = 0; i < e.response.data.errors.length; i++) {
                  if (
                    e.response.data.errors[i].detail ==
                    "This action is unauthorized."
                  ) {
                    this.$router.push({ name: "PageAccessDenied" });
                  } else {
                    this.alertValue = true;
                    this.alertType = "error";
                    this.alertMsg = i18n.t("serverError");
                  }
                }
              } else {
                this.alertValue = true;
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
              }
            }
          }
        }
      }
    },
    showEditTitleField(item) {
      for (let i = 0; i < this.pages.length; i++) {
        this.hideEditTitleField(this.pages[i]);
      }
      Vue.set(item, "edit", !item.edit);
    },
    hideEditTitleField(item) {
      if (item.edit == true) {
        Vue.set(item, "edit", false);
      }
    },
    async onClickOutside() {
      for (let i = 0; i < this.pages.length; i++) {
        this.hideEditTitleField(this.pages[i]);
      }
      this.getActivityPages();
    },
    redirectToActivityPage(pageId) {
      this.$router
        .push({ path: "/activity/" + this.activityId + "/page/" + pageId })
        .catch(() => {});
    },
    redirectToActivityQuiz(quizId) {
      this.$router
        .push({ path: "/activity/" + this.activityId + "/quiz/" + quizId })
        .catch(() => {});
    },
    redirectToActivityScorm(scormId) {
      this.$router
        .push({ path: "/activity/" + this.activityId + "/scorm/" + scormId })
        .catch(() => {});
    },
    redirectToActivitySurvey(surveyId) {
      this.$router
        .push({ path: "/activity/" + this.activityId + "/survey/" + surveyId })
        .catch(() => {});
    },
    redirectToActivityChecklist(checklistId) {
      this.$router
        .push({
          path: "/activity/" + this.activityId + "/checklist/" + checklistId,
        })
        .catch(() => {});
    },
    onStart(evt) {
      if (evt.item.classList.contains("section")) {
        this.isSectionDragged = true;
      }
      this.isDragging = true;
    },
    async onEnd() {
      this.dragOverId = null;
      this.isSectionDragged = false;
      await this.reorderActivityFeedItems();
    },

    checkIfOpen(id) {
      if (id == this.dragOverId) {
        let dragOverSection = this.list.find(
          (item) => item.id === id && item.entity_type == "section"
        );
        if (dragOverSection) {
          dragOverSection.active = true;
        }
      }
    },

    onMove(evt) {
      this.dragOverId = null;
      let vm = this;
      if (evt.related.attributes.dragid) {
        let draggedIdNotSection = this.list.find(
          (item) =>
            item.id === evt.dragged.attributes.dragid.value &&
            item.entity_type != "section"
        );
        if (draggedIdNotSection) {
          let dragOverSection = this.list.find(
            (item) =>
              item.id === evt.related.attributes.dragid.value &&
              item.entity_type == "section"
          );
          if (dragOverSection) {
            this.dragOverId = evt.related.attributes.dragid.value;
            setTimeout(function () {
              vm.checkIfOpen(evt.related.attributes.dragid.value);
            }, 1000);
          }
        }
      }
    },

    async onChangeInSection(evt, item) {
      if (evt.removed) {
        if (
          this.list.find(
            ({ entity_id }) => entity_id === evt.removed.element.entity_id
          )
        ) {
          evt.removed.element.section_id = null;
        }
      }
      if (evt.added) {
        evt.added.element.section_id = item.entity_id;
      }
    },

    async onEndInSection() {
      this.isSectionDragged = false;
      await this.reorderActivityFeedItems();
    },
    async reorderActivityFeedItems() {
      this.listRequest = [];
      let position = 0;

      for (let i = 0; i < this.list.length; i++) {
        this.listRequest.push({
          id: this.list[i].id,
          position: position++,
          section_id: this.list[i].section_id,
        });
        if (this.list[i].tasks && this.list[i].tasks.length > 0) {
          for (let t = 0; t < this.list[i].tasks.length; t++) {
            this.listRequest.push({
              id: this.list[i].tasks[t].id,
              position: position++,
              section_id: this.list[i].tasks[t].section_id,
            });
          }
        }
      }

      //set defaultPage
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].is_published == true) {
          if (this.list[i].entity_type != "section") {
            this.activityDefaultItemId = this.list[i].id;
            break;
          } else {
            if (this.list[i].tasks && this.list[i].tasks.length > 0) {
              for (let t = 0; t < this.list[i].tasks.length; t++) {
                if (this.list[i].tasks[t].is_published == true) {
                  this.activityDefaultItemId = this.list[i].tasks[t].id;
                  break;
                }
              }
            }
          }
          break;
        }
      }

      try {
        let data = {
          data: {
            type: "activities",
            attributes: {
              activity_feed_items: this.listRequest,
            },
          },
        };
        const response = await reorderActivityFeedItems(
          this.$route.params.id,
          data
        );
        if (response.status == 200) {
          //console.log('200')
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 422) {
            for (let i = 0; i < e.response.data.errors.length; i++) {
              if (e.response.data.errors[i].meta[0].code == "itemWithRule") {
                this.dialogVisibleInfo = true;
                this.infoDialogTitle = i18n.t(
                  "infoDialogPreventReorderingTitle"
                );
                this.infoDialogText = i18n.t("infoDialogPreventReorderingText");
                const response_pages = await getActivityPages(this.activityId);
                eventBus.$emit(
                  "changeNavigationInActivity",
                  response_pages.data.data
                );
              }
            }
            //error
          }
        }
      }
    },
    async setActivityItemRule(type, item, date) {
      if (type == "feedItemDependent") {
        if(item.id != this.selectedActivityItem.rule_item_id){
          //set rule
          try {
            let data = {
              data: {
                type: "activity-rules",
                attributes: {
                  item_id: item.id,
                  available_after: null,
                },
              },
            };
            const response = await setActivityRule(
              this.selectedActivityItem.id,
              data
            );
            if (response.status == 200) {
              this.dialogVisibleSetRule = false
              this.alertValue = true;
              this.alertType = "success";
              this.alertMsg = i18n.t("setActivityRuleSuccess");
              const response_pages = await getActivityPages(this.activityId);
              eventBus.$emit(
                "changeNavigationInActivity",
                response_pages.data.data
              );
            }
          } catch (e) {
            if (e.response) {
              this.dialogVisibleSetRule = false
              if (e.response.status == 422) {
                for (let i = 0; i < e.response.data.errors.length; i++) {
                  this.alertValue = true;
                  this.alertType = "error";
                  if(e.response.data.errors[i].meta){
                    if (
                      e.response.data.errors[i].meta[0].code == "default item"
                    ) {
                      this.alertMsg = i18n.t("setActivityRuleErrorDefaultItem");
                    } else if (
                      e.response.data.errors[i].meta[0].code ==
                      "circular dependency"
                    ) {
                      this.alertMsg = i18n.t("setActivityRuleErrorCircular");
                    } else {
                      this.alertMsg = i18n.t("serverError");
                    }
                  }else{
                    this.alertMsg = i18n.t("serverError");
                  }
                }
              } else if (e.response.status == 403) {
                this.$router.push({ name: "PageAccessDenied" });
              } else {
                this.alertValue = true;
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
              }
            }
          }
        }
        this.dialogVisibleSetRule = false
      } else if(type == 'dateDependent'){
          if(moment(date).format('YYYY-MM-DD HH:mm') != moment(this.selectedActivityItem.rule_available_after).format('YYYY-MM-DD HH:mm')){
            try {
            let data = {
              data: {
                type: "activity-rules",
                attributes: {
                  item_id: null,
                  available_after: date,
                },
              },
            };
            const response = await setActivityRule(
              this.selectedActivityItem.id,
              data
            );
            if (response.status == 200) {
              this.dialogVisibleSetRule = false;
              this.alertValue = true;
              this.alertType = "success";
              this.alertMsg = i18n.t("setActivityRuleSuccess");
              const response_pages = await getActivityPages(this.activityId);
              eventBus.$emit(
                "changeNavigationInActivity",
                response_pages.data.data
              );
            }
          } catch (e) {
            if (e.response) {
              this.dialogVisibleSetRule = false
              if (e.response.status == 422) {
                for (let i = 0; i < e.response.data.errors.length; i++) {
                  this.alertValue = true;
                  this.alertType = "error";
                  if(e.response.data.errors[i].meta){
                    if (
                      e.response.data.errors[i].meta[0].code == "default item"
                    ) {
                      this.alertMsg = i18n.t("setActivityRuleErrorDefaultItem");
                    } else if (
                      e.response.data.errors[i].meta[0].code ==
                      "circular dependency"
                    ) {
                      this.alertMsg = i18n.t("setActivityRuleErrorCircular");
                    }else if (
                      e.response.data.errors[i].meta[0].code ==
                      "available_after is in past"
                    ) {
                      this.alertMsg = i18n.t("setRuleDateTimePastDateError");
                    } else {
                      this.alertMsg = i18n.t("serverError");
                    }
                  }else{
                    this.alertMsg = i18n.t("serverError");
                  }
                }
              } else if (e.response.status == 403) {
                this.$router.push({ name: "PageAccessDenied" });
              } else {
                this.alertValue = true;
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
              }
            }
          }
        }
        this.dialogVisibleSetRule = false        
      }else {
        if(this.selectedActivityItem.rule_available_after != null || this.selectedActivityItem.rule_item_id != null){
          try {
            let data = {
              data: {
                type: "activity-rules",
                attributes: {
                  item_id: null,
                  available_after: null,
                },
              },
            };
            const response = await setActivityRule(
              this.selectedActivityItem.id,
              data
            );
            if (response.status == 200) {
              this.dialogVisibleSetRule = false
              this.alertValue = true;
              this.alertType = "success";
              this.alertMsg = i18n.t("removeActivityRuleSuccess");
              const response_pages = await getActivityPages(this.activityId);
              eventBus.$emit(
                "changeNavigationInActivity",
                response_pages.data.data
              );
            }
          } catch (e) {
            if (e.response) {
              this.dialogVisibleSetRule = false
              this.alertValue = true;
              this.alertType = "error";
              this.alertMsg = i18n.t("serverError");
            }
          }
        }
        this.dialogVisibleSetRule = false 
      }
    },
    async duplicateDraftFeedItemActivity(item) {
      //duplicate draft
      if (
        item.is_published == false ||
        (item.is_published == true && item.has_draft == true)
      ) {
        try {
          let data = {
            data: {
              type: "activity-feed-items",
              attributes: {
                keep_published: false,
              },
            },
          };
          const response = await duplicateFeedItemActivity(item.id, data);
          if (response.status == 201) {
            await this.getActivityPages();
            let item_type = response.data.data.type;
            if (item_type == "activity-pages") {
              this.$router.push({
                name: "ViewActivityPage",
                params: {
                  id: this.$route.params.id,
                  pageId: response.data.data.id,
                  successfullyCreatedActivityPage: true,
                },
              });
            } else if (item_type == "quizzes") {
              this.$router.push({
                name: "ViewActivityQuiz",
                params: {
                  id: this.$route.params.id,
                  quizId: response.data.data.id,
                  successfullyCreatedActivityQuiz: true,
                },
              });
            } else if (item_type == "scorms") {
              this.$router.push({
                name: "ViewActivityScorm",
                params: {
                  id: this.$route.params.id,
                  scormId: response.data.data.id,
                  successfullyAddedActivityScorm: true,
                },
              });
            } else if (item_type == "checklists") {
              this.$router.push({
                name: "ViewActivityChecklist",
                params: {
                  id: this.$route.params.id,
                  checklistId: response.data.data.id,
                  successfullyCreatedActivityChecklist: true,
                },
              });
            } else {
              this.$router.push({
                name: "ViewActivitySurvey",
                params: {
                  id: this.$route.params.id,
                  surveyId: response.data.data.id,
                  successfullyCreatedActivitySurvey: true,
                },
              });
            }
          }
        } catch (e) {
          if (e.response) {
            if (e.response.status == 422) {
              this.alertValue = true;
              this.alertType = "error";
              this.alertMsg = i18n.t("serverError");
            } else if (e.response.status == 403) {
              this.$router.push({ name: "PageAccessDenied" });
            } else {
              this.alertValue = true;
              this.alertType = "error";
              this.alertMsg = i18n.t("serverError");
            }
          }
        }
      }
    },

    async duplicatePublishedFeedItemActivity(item) {
      //duplicate published
      if (
        item.is_published == true ||
        (item.is_published == true && item.has_draft == true)
      ) {
        try {
          let data = {
            data: {
              type: "activity-feed-items",
              attributes: {
                keep_published: true,
              },
            },
          };
          const response = await duplicateFeedItemActivity(item.id, data);
          if (response.status == 201) {
            await this.getActivityPages();
            let item_type_published = response.data.data.type;
            if (item_type_published == "activity-pages") {
              this.$router.push({
                name: "ViewActivityPage",
                params: {
                  id: this.$route.params.id,
                  pageId: response.data.data.id,
                  successfullyCreatedActivityPage: true,
                },
              });
            } else if (item_type_published == "quizzes") {
              this.$router.push({
                name: "ViewActivityQuiz",
                params: {
                  id: this.$route.params.id,
                  quizId: response.data.data.id,
                  successfullyCreatedActivityQuiz: true,
                },
              });
            } else if (item_type_published == "scorms") {
              this.$router.push({
                name: "ViewActivityScorm",
                params: {
                  id: this.$route.params.id,
                  scormId: response.data.data.id,
                  successfullyAddedActivityScorm: true,
                },
              });
            } else if (item_type_published == "checklists") {
              this.$router.push({
                name: "ViewActivityChecklist",
                params: {
                  id: this.$route.params.id,
                  checklistId: response.data.data.id,
                  successfullyCreatedActivityChecklist: true,
                },
              });
            } else {
              this.$router.push({
                name: "ViewActivitySurvey",
                params: {
                  id: this.$route.params.id,
                  surveyId: response.data.data.id,
                  successfullyCreatedActivitySurvey: true,
                },
              });
            }
          }
        } catch (e) {
          if (e.response.status == 422) {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          } else if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }
    }
  }
};
</script>
<style>
.areaInSection {
  min-height: 30px;
  margin-left: 30px;
}
.areaInSection .title,
.activity-page-item span.title {
  max-width: 226px;
}
.custom-width {
  width: 100%;
}
.areaNavBar .v-list-item__icon {
  margin: 12px 4px 12px 0 !important;
}

.areaNavBar .v-list-item--active .v-list-item--active span.title,
.areaNavBar .areaInSection .v-list-item--active span.title {
  color: var(--v-anchor-base) !important;
}

.areaNavBar .v-list-item--active .v-list-item--active .v-list-item__icon,
.areaNavBar .areaInSection .v-list-item--active .v-list-item__icon {
  color: var(--v-anchor-base) !important;
}

.areaNavBar
  .v-list-item--active
  .v-list-item--active
  .v-list-item__icon
  .success--text {
  color: var(--v-success-base) !important;
}
.areaNavBar
  .v-list-item--active
  .v-list-item--active
  .v-list-item__icon
  .warning--text {
  color: var(--v-warning-base) !important;
}
.areaNavBar .v-list-item__icon.mdi-text,
.areaNavBar .v-list-item__icon.mdi-chat-question-outline,
.areaNavBar .v-list-item__icon.mdi-order-bool-ascending-variant,
.areaNavBar .v-list-item__icon.mdi-help-box-multiple-outline {
  color: var(--v-greytext-base) !important;
  font-size: 20px;
}
.areaNavBar .v-list-item__icon.mdi-text.success--text,
.areaNavBar .v-list-item__icon.mdi-chat-question-outline.success--text,
.areaNavBar .v-list-item__icon.mdi-order-bool-ascending-variant.success--text,
.areaNavBar .v-list-item__icon.mdi-help-box-multiple-outline.success--text {
  color: var(--v-success-base) !important;
}
.areaNavBar .v-list-item--active .v-list-item--active .v-list-item__icon.mdi-text.success--text,
.areaNavBar .v-list-item--active .v-list-item--active .v-list-item__icon.mdi-chat-question-outline.success--text,
.areaNavBar .v-list-item--active .v-list-item--active .v-list-item__icon.mdi-order-bool-ascending-variant.success--text,
.areaNavBar .v-list-item--active .v-list-item--active .v-list-item__icon.mdi-help-box-multiple-outline.success--text {

  color: var(--v-anchor-base) !important;
}
.areaNavBar .v-list-item__icon.mdi-text.warning--text,
.areaNavBar .v-list-item__icon.mdi-chat-question-outline.warning--text,
.areaNavBar .v-list-item__icon.mdi-order-bool-ascending-variant.warning--text,
.areaNavBar .v-list-item__icon.mdi-help-box-multiple-outline.warning--text {

  color: var(--v-warning-base) !important;
}
.areaNavBar .v-list-item--active .v-list-item--active .v-list-item__icon.mdi-text.warning--text,
.areaNavBar .v-list-item--active .v-list-item--active .v-list-item__icon.mdi-chat-question-outline.warning--text,
.areaNavBar .v-list-item--active .v-list-item--active .v-list-item__icon.mdi-order-bool-ascending-variant.warning--text,
.areaNavBar .v-list-item--active .v-list-item--active .v-list-item__icon.mdi-help-box-multiple-outline.warning--text {

  color: var(--v-anchor-base) !important;
}
.areaNavBar .v-list-item__icon.mdi-text.locked-content,
.areaNavBar .v-list-item__icon.mdi-chat-question-outline.locked-content,
.areaNavBar .v-list-item__icon.mdi-order-bool-ascending-variant.locked-content,
.areaNavBar .v-list-item__icon.mdi-help-box-multiple-outline.locked-content {

  color: var(--v-greytextlight-base) !important;
}
.areaNavBar .v-list-item--active .v-list-item--active .v-list-item__icon.mdi-text.locked-content,
.areaNavBar .v-list-item--active .v-list-item--active .v-list-item__icon.mdi-chat-question-outline.locked-content,
.areaNavBar .v-list-item--active .v-list-item--active .v-list-item__icon.mdi-order-bool-ascending-variant.locked-content,
.areaNavBar .v-list-item--active .v-list-item--active .v-list-item__icon.mdi-help-box-multiple-outline.locked-content {

  color: var(--v-anchor-base) !important;
}
.areaNavBar .text-right .v-btn--round {
  left: -4px;
}
.areaNavBar .v-list-group--sub-group .v-list-group__header {
  padding: 0 !important;
  padding-left: 12px !important;
}

.areaNavBar .dots-vertical {
  display: none;
}

.areaNavBar .v-list-item:hover .dots-vertical,
.areaNavBar .v-list-item--active .v-list-item--active .dots-vertical,
.areaNavBar .areaInSection .v-list-item--active .dots-vertical {
  display: initial;
}

.activity-feed-draft-tag {
  font-size: 10px !important;
  height: 18px !important;
  vertical-align: text-bottom;
}
</style>